import { component_tool, framework_tool,utils_tool } from '@/tool';
let { WizModal, WizNotice } = component_tool;
import moment from "moment";
import React from "react";
import SurveyInfoList from "./surveyInfoList"
import { getLocationOrgin } from '@/utils/commonUtils';
let {Session} = utils_tool

let ref;
//配置项
let componentName = 'interactLive'


const columns =(isAdmin)=>{
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "直播课堂名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "开始时间",
      name: "startDate",
      dataIndex: "startDate",
      width: 150,
      tableItem: {}
    },
    {
      title: "结束时间",
      name: "endDate",
      dataIndex: "endDate",
      width: 150,
      tableItem: {}
    },
  
    {
      title: "开始时间",
      name: "startTimeAll",
      dataIndex: "startTimeAll",
      formItem: {},
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "结束时间",
      name: "endTimeAll",
      dataIndex: "endTimeAll",
      formItem: {},
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    isAdmin?{
      title: "讲师",
      name: "hostName",
      dataIndex: "hostName",
      width: 150,
      searchItem: {
      },
    }:{},
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {},
      dict: [
       // { code: 1, codeName: "草稿" },
        { code: 2, codeName: "预告" },
        { code: 3, codeName: "进行中" },
        { code: 4, codeName: "已结束" }
      ],
      searchItem: {
        type: "select"
      },
    },
    {
      title: "讲师",
      name: "hostName",
      dataIndex: "hostName",
      width: 150,
      tableItem: {}
    },
  ];
} 

const templateConfig =(isAdmin)=>{
  console.log("isAdmin==",isAdmin)
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns(isAdmin),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            let startTimeAll = value.startTimeAll;
            if (startTimeAll && startTimeAll.length === 2) {
              value.startDateStart = moment(startTimeAll[0]).format('YYYY-MM-DD HH:mm:ss')
              value.startDateEnd = moment(startTimeAll[1]).format('YYYY-MM-DD HH:mm:ss')
            }else{
              value.startDateStart = null;
              value.startDateEnd = null;
            }
            let endTimeAll = value.endTimeAll;
            if (endTimeAll && endTimeAll.length === 2) {
              value.endDateStart = moment(endTimeAll[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDateEnd = moment(endTimeAll[1]).format('YYYY-MM-DD HH:mm:ss')
            }else{
              value.endDateStart = null;
              value.endDateEnd = null;
            }
            return value
          },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: false,
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['open','enter','questionnaireRecord','videoPlayback','close'],// 'manager',
        rowOperateView: [
          {
            key: "open",
            custom: true,
            params: { children: "开启课堂" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'setInteractLiveState'
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '您确定要开启该课堂吗？'
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record.id,
                      state: 3
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.state != 2) {
                result.disabled = true
              }
              return result
            },
          },
          {
            key: "enter",
            custom: true,
            params: { children: "进入课堂"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "openUrl"
              },
              formatParams: (rows, record, filters, callback) => {
                let user = storage.getStorage("user");
                let url = getLocationOrgin() + '/#/hostHktList/hktClassroom'
                Session.set('hktClassroom', {...record,avatar:user.avatar})
                window.open(url, '_blank')
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.state != 3) {
                result.disabled = true
              }
              return result
            },
          },
          // {
          //   key: "questionnaireRecord",
          //   custom: true,
          //   params: { children: "问卷管理" },
          //   customOnClick: {
          //     key: "action",
          //     params: {
          //       apiKey: "questionnaireRecord",
          //       apiParams: {}
          //     },
          //     formatParams: (rows, record, filters, callback) => {
          //       callback({
          //         liveType:record.liveType,
          //         id:record.id,
          //       })
          //     }
          //   },
          //   recordChangeParams: (record, rows) => {
          //     // let result = { disabled: true, hidden: true };
          //     // if (record.record && record.record.liveType ===1) {
          //     //   result.disabled = false
          //     //   if ( record.record.liveVideoType ===4){
          //     //     result.hidden = false
          //     //   }
          //     // }
          //     // return result
          //   },
          // },
          {
            key: "questionnaireRecord",
            custom: true,
            params: { children: "问卷管理" },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'questionnaireRecord',
                modalParams: {
                  title: "问卷管理",
                  destroyOnClose: true,
                  footer: null,
                  width:800,
                  diy: (e) => {
                    const { record, changeModal } = e || {}
                    const { id } = record || {}
                    const timestamp = new Date().getTime()
                    return <SurveyInfoList
                      personId={id}
                      timestamp={timestamp}
                      record={record}
                      close={() => changeModal && changeModal(false, false, false)}
                    />
                  },
                }
              }
            },
            // recordChangeParams: (record, rows) => {
            //   let result = { disabled: true };
            //   if (record.record && (record.record.state >= 3)) {
            //     result.disabled = false
            //   }
            //   return result
            // },
          },
          {
            key: "close",
            custom: true,
            params: { children: "结束课堂" },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'setInteractLiveState'
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '您确定要结束该课堂吗？'
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record.id,
                      state: 4
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.state != 3) {
                result.disabled = true
              }
              return result
            },
          },
          // {
          //   key: "videoPlayback",
          //   name: 'WizButton',
          //   params: { children: "录像回看" },
          //   onClick: (e) => {
          //     const { record } = e || {}
          //     WizModal.warn({
          //       title: "温馨提醒",
          //       content: "录像回看暂未实现",
          //     })
          //   },
          //   recordChangeParams: (record, rows) => {
          //     // let result = { disabled: false };
          //     // if (record.record && (record.record.state === 2)) {
          //     //   result.disabled = true
          //     // }
          //     // return result
          //   },
          // },
        ],
        commonOperate: {}
      }
    }
  };
} 





const apis = {
  list: {
    path: `${componentName}/classRoomHostListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {videoTool:2,liveType:5}
    }
  },
  export: {
    path: `${componentName}/classRoomHostList`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {videoTool:2,liveType:5}
    }
  },
  setInteractLiveState: {
    path: `${componentName}/setInteractLiveState`,
    payload: {
      key: `${componentName}@setInteractLiveState`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
